import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse} from '@angular/common/http';
import { catchError, filter, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private token;
  private expiration;
    constructor(private tokensService: TokenService, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      const uri = req.url.replace(environment.api_url, '')
      this.token = this.tokensService.getToken();
      this.expiration = this.tokensService.getExpirationDate();
  
     /*  if (new Date(this.expiration) < new Date() && this.expiration != null) {
        this.tokensService.clear();
        this.router.navigate(['/account/login']);
      } */
      if (uri.startsWith('/api') && req.method !== 'OPTIONS' && this.token != null) {
        const request = req.clone({
          headers: new HttpHeaders({
            Authorization: 'Bearer ' + this.token.access_token
          })
        });
  
        return next.handle(request).pipe(
          filter(event => event instanceof HttpResponse),
          tap((event: HttpResponse<any>) => {
            if ([401].indexOf(event.body.resultCode) !== -1) {
              this.tokensService.clear();
              this.router.navigate(['/account/login']);
            }
            return throwError(event.body.resultCode);
          }),
          catchError(err => {
            if ([401, 403].indexOf(err.status) !== -1) {
              this.tokensService.clear();
              this.router.navigate(['/account/login']);
            }
            return throwError(err);
          }
          ));
  
  
  
  
  
  
  
  
  
      }
  
  
      return next.handle(req);
    }
  
  
  }
  
